<script>
  export default {
    name: 'list-edit-button',
    props: ['routeName', 'domain', 'item']
  }
</script>

<template>
    <router-link :to="{ name: routeName, params: { id: item.id } }"
                 class="el-button el-button--info"
                 v-if="$can(domain + '.update')"
                 title="Editar Dados">
        <i class="el-icon-edit"></i>
    </router-link>
</template>



// WEBPACK FOOTER //
// EditButton.vue?d6010d00